export enum NeritClinSystemApiEnum {
    NERITCLIN_API = 'NERITCLIN_API',
}
